import { ExportData, FormList, HeaderTitle, Thumbnails } from '@/components';
import { getUserList, addUserBill, getUserBill } from '@/api';
import { Col, InputNumber, Input, message, Modal, Row, Select, Spin, Table } from 'antd';
import { calcPrice, toDateTime } from '@/utils/utils';
import React, { useState } from 'react';
import { useTable } from '@/hooks';

const kindObj = {
  admin: '管理编辑',
  noAuctionReward: '拍不到奖励',
  noAuctionShareReward: '拍不到分享奖励',
  subscriptionConsume: '商城商品兑换',
  userPremiumIncome: '竞拍成交奖励',
};

const typeObj = {
  1: '收入',
  '-1': '支出',
};
function FinanceBill() {
  const [body, setBody] = useState({});
  const [query, setQuery] = useState({});
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const columns = {
    id: '编号',
    // number: '单号',
    userId: '用户编号',
    NOINDEX_User: {
      title: '用户名称',
      render: e => {
        const { User = {} } = e;
        return User?.nickname || '-';
      },
    },
    User: {
      title: '用户头像',
      render: e => <Thumbnails images={[e?.avatarUrl]} center />,
    },
    amount: {
      title: '额度数量',
      render: e => {
        return calcPrice(e)
      },
    },
    change: {
      title: '额度变化',
      render: e => {
        return calcPrice(e)
      },
    },
    changedAmount: {
      title: '剩余余额',
      render: e => {
        return calcPrice(e)
      },
    },
    kind: {
      title: '账单类别',
      render: e => kindObj[e] || e,
    },
    type: {
      title: '类型',
      render: e => typeObj[e] || e,
    },
    describe: '备注信息',
    sourceId: '来源编号',
    source: '来源名称',
    createdAt: {
      title: '创建时间',
      render: e => toDateTime(e),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    isInit: false,
    API: getUserBill,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'userId',
      label: '用户编号',
    },
    {
      id: 'kind',
      label: '收入类别',
      type: 'select',
      selects: kindObj,
      // hideItem: query.type != 1,
      options: {
        mode: 'multiple',
        maxTagCount: 1,
      },
    },
    {
      id: 'createTime',
      label: '生成时间',
      type: 'rangeTime',
    },
  ];

  const changeQuery = (value = {}) => {
    const { kind = [], createTime } = value;
    const [starts, ends] = createTime || [];
    const q = {
      ...value,
      ...(createTime && {
        createdStartTime: toDateTime(starts),
        createdEndTime: toDateTime(ends),

      }),
      kind: kind.join(','),
    };

    setQuery(q);
    flagFn(true);
  };

  const handleSubmit = async () => {
    if (Object.values(body).filter(i => i).length < 3) {
      message.warning('请将数据填写完整');
      return;
    }
    try {
      setLoading(true);
      const res = await getUserList({
        query: {
          id: body.userId,
        },
      });
      if (res.data.length === 1) {
        await addUserBill({
          body,
        });
        message.success('添加成功');
        setVisible(false);
        setLoading(false);
        setBody({});
        flagFn();
      } else {
        message.warning('输入的用户不存在！');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <HeaderTitle title="增减余额" onClick={() => setVisible(true)} />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <ExportData
            API={getUserBill}
            title="认购账单列表"
            query={query}
            extend={{
              amount: 'amount',
              createdAt: 'time',
              // kind: kindObj,
            }}
            columns={{
              id: '编号',
              number: '单号',
              userId: '用户编号',
              'User.nickname': '用户昵称',
              amount: '额度数量',
              kind: '认购类型',
              describe: '备注信息',
              sourceId: '来源编号',
              source: '来源名称',
              createdAt: '创建时间',
            }}
          />
        }
      />
      <Table {...tableProps} />
      <Modal
        destroyOnClose
        title="增减贡献值"
        visible={visible}
        confirmLoading={loading}
        onCancel={() => setVisible(false)}
        onOk={() => handleSubmit()}
      >
        <Spin spinning={loading}>
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              用户编号:
            </Col>
            <InputNumber
              min={1}
              precision={0}
              max={999999999}
              controls={false}
              placeholder="请输入用户编号"
              style={{ width: '280px' }}
              onChange={e => {
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.userId = e;
                  return newHis;
                });
              }}
            />
          </Row>
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              额度数量:
            </Col>
            <InputNumber
              precision={2}
              placeholder="请输入额度数量,负数为扣除"
              style={{ width: '280px' }}
              onChange={e => {
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.change = Math.floor(e * 100);
                  return newHis;
                });
              }}
            />
          </Row>
          <Row style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
            <Col span={6} style={{ textAlign: 'right', paddingRight: '22px' }}>
              备注:
            </Col>
            <Input
              // min={0}
              precision={3}
              placeholder="请输入备注"
              style={{ width: '280px' }}
              onChange={e => {
                let value = e?.target?.value
                setBody(his => {
                  const newHis = Object.assign({}, his);
                  newHis.describe = value;
                  return newHis;
                });
              }}
            />
          </Row>
        </Spin>
      </Modal>
    </>
  );
}

export default FinanceBill;
